import React, { useState, useEffect } from 'react'
import { FaAngleRight } from "react-icons/fa";
import Icon from '../../components/Icons/Icon';
import Modal from 'react-modal';
import Pharmacies from '../Pharmacies/Pharmacies';
import { getSiteSettings } from '../../api/siteSettings';

const servicesData = [
    {
        id: 1,
        title: "CİMER",
        icon: "cimer",
        link: "https://www.cimer.gov.tr/",
        iconColor: "#495057",
        targetBlank: true
    },
    {
        id: 2,
        title: "Nikah İşlemleri",
        icon: "nikah",
        link: "/nikah-islemleri",
        iconColor: "#FF6B6B",
        targetBlank: false
    },
    {
        id: 3,
        title: "Beyaz Masa",
        icon: "beyaz-masa",
        link: "#", // Placeholder, will be replaced with dynamic URL from API
        iconColor: "#4ECDC4",
        targetBlank: true
    },
    {
        id: 4,
        title: "Nöbetçi Eczaneler",
        icon: "nobetci-eczane",
        link: "#",
        isPharmacy: true,
        iconColor: "#A8E6CF",
        targetBlank: false
    },
    {
        id: 5,
        title: "İmar Hizmetleri",
        icon: "imar",
        link: "https://keos.iskenderun.bel.tr:8787/imardurumu/index.aspx",
        comingSoon: false,
        iconColor: "#FFD93D",
        targetBlank: true
    },
    {
        id: 6,
        title: "Çöp Hizmetleri",
        icon: "cop-hizmetleri",
        link: "#",
        comingSoon: true,
        iconColor: "#6C5CE7",
        targetBlank: false
    },
    {
        id: 7,
        title: "Parklar",
        icon: "parklar",
        link: "/parklar",
        iconColor: "#20C997",
        targetBlank: false
    },
    {
        id: 8,
        title: "Sosyal Tesisler",
        icon: "sosyal-tesis",
        link: "/sosyal-tesisler",
        comingSoon: false,
        iconColor: "#FF69B4",
        targetBlank: false
    },
    {
        id: 9,
        title: "Meclis Kararları",
        icon: "meclis",
        link: "/meclis-kararlari",
        comingSoon: false,
        iconColor: "#8B9467",
        targetBlank: false
    }
];

export default function ServicesGrid() {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [comingSoonModalIsOpen, setComingSoonModalIsOpen] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [siteSettings, setSiteSettings] = useState(null);
    const [services, setServices] = useState(servicesData);

    useEffect(() => {
        const fetchSiteSettings = async () => {
            try {
                const response = await getSiteSettings();
                if (response.isSuccess) {
                    setSiteSettings(response.data);
                    
                    // Update the services array with dynamic URLs
                    const updatedServices = servicesData.map(service => {
                        if (service.id === 3) { // Beyaz Masa
                            return {
                                ...service,
                                link: response.data.whiteDeskUrl || service.link
                            };
                        }
                        return service;
                    });
                    
                    setServices(updatedServices);
                }
            } catch (error) {
                console.error('Error fetching site settings:', error);
            }
        };

        fetchSiteSettings();
    }, []);

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: '900px',
            maxHeight: '90vh',
            overflow: 'auto'
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)'
        }
    };

    const comingSoonStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: '500px',
            textAlign: 'center',
            padding: '30px'
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)'
        }
    };

    const handleServiceClick = (e, service) => {
        e.preventDefault();
        if (service.comingSoon) {
            setSelectedService(service);
            setComingSoonModalIsOpen(true);
        } else if (service.isPharmacy) {
            setModalIsOpen(true);
        } else if (service.link !== "#") {
            if (service.targetBlank) {
                window.open(service.link, '_blank', 'noopener,noreferrer');
            } else {
                window.location.href = service.link;
            }
        }
    };

    Modal.setAppElement('#root');

    return (
        <div className="services-grid">
            <div className="services-grid-title">
                <h2>Hizmetlerimiz</h2>
                <p>Size sunduğumuz tüm hizmetlere ilgili tüm bilgilere bu alandan ulaşabilirsiniz.</p>
            </div>

            <div className="services-grid-content">
                <div className="services-grid-content-card row">
                    {services.map((service) => (
                        <a 
                            key={service.id} 
                            href={service.link} 
                            className="services-card col-md-4" 
                            onClick={(e) => handleServiceClick(e, service)}
                            target={service.targetBlank ? "_blank" : ""}
                            rel={service.targetBlank ? "noopener noreferrer" : ""}
                        >
                            <div className="services-card-left">
                                <div className="services-card-icon">
                                    {service.title === "CİMER" ? (
                                        <img src="/assets/images/cimer.png" alt="Cimer" />
                                    ) : (
                                        <Icon icon={service.icon} size="40" color={service.iconColor} />
                                    )}
                                    <h4>{service.title}</h4>
                                </div>
                            </div>
                            <div className="services-card-right">
                                <div className="services-card-arrow">
                                    <span>
                                        <Icon icon="arrow-right" size="28" color="#918D8D" />
                                    </span>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                style={customStyles}
                contentLabel="Nöbetçi Eczaneler"
            >
                <button 
                    onClick={() => setModalIsOpen(false)}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '10px',
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer'
                    }}
                >
                    ×
                </button>
                <Pharmacies />
            </Modal>

            <Modal
                isOpen={comingSoonModalIsOpen}
                onRequestClose={() => setComingSoonModalIsOpen(false)}
                style={comingSoonStyles}
                contentLabel="Yakında"
            >
                <button 
                    onClick={() => setComingSoonModalIsOpen(false)}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '10px',
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer'
                    }}
                >
                    ×
                </button>
                <div style={{ marginBottom: '20px' }}>
                    <img src="/assets/images/logo.png" alt="Logo" style={{ maxWidth: '200px' }} />
                </div>
                <h3 style={{ color: '#0F75BC', marginBottom: '20px' }}>
                    {selectedService?.title}
                </h3>
                <p style={{ fontSize: '18px', color: '#333' }}>
                    Yakında Hizmetinize Açılacaktır
                </p>
            </Modal>
        </div>
    )
}
